export default "__VITE_ASSET__DdMoEBkd__"